<template>
  <div :style="{width,height}">
    {{ratio}} {{loaded}}
    <img ref="img"
         :src="url"
         :width="width"
         :height="imageHeight" />
  </div>
</template>
<script>
export default {
    data() {
        return {
            ratio: 0,
            loaded: false
        };
    },
    mounted() {
        const $el = this.$refs.img;

        $el.onload = function() {
            this.loaded = true;
            this.ratio = $el.naturalWidth / $el.naturalHeight;
        };
    },
    computed: {
        imageWidth: function() {
            return this.width;
        },
        imageHeight: function() {
            return parseInt(this.width) / this.ratio;
        }
    },
    props: {
        width: {
            default: '0',
            type: String
        },
        height: {
            default: '0',
            type: String
        },
        url: {
            default: '',
            type: String
        }
    }
};
</script>

<style scoped>
div {
    background: #ccc;
    display: flex;
}
</style>
